import { render, staticRenderFns } from "./deptmanage.vue?vue&type=template&id=75550052"
import script from "./deptmanage.vue?vue&type=script&lang=js"
export * from "./deptmanage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports